var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00016 14.6693C11.6668 14.6693 14.6668 11.6693 14.6668 8.0026C14.6668 4.33594 11.6668 1.33594 8.00016 1.33594C4.3335 1.33594 1.3335 4.33594 1.3335 8.0026C1.3335 11.6693 4.3335 14.6693 8.00016 14.6693Z",
    stroke: "#1E2A3B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00016 14.6693C11.6668 14.6693 14.6668 11.6693 14.6668 8.0026C14.6668 4.33594 11.6668 1.33594 8.00016 1.33594C4.3335 1.33594 1.3335 4.33594 1.3335 8.0026C1.3335 11.6693 4.3335 14.6693 8.00016 14.6693Z",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00016 14.6693C11.6668 14.6693 14.6668 11.6693 14.6668 8.0026C14.6668 4.33594 11.6668 1.33594 8.00016 1.33594C4.3335 1.33594 1.3335 4.33594 1.3335 8.0026C1.3335 11.6693 4.3335 14.6693 8.00016 14.6693Z",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00016 14.6693C11.6668 14.6693 14.6668 11.6693 14.6668 8.0026C14.6668 4.33594 11.6668 1.33594 8.00016 1.33594C4.3335 1.33594 1.3335 4.33594 1.3335 8.0026C1.3335 11.6693 4.3335 14.6693 8.00016 14.6693Z",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00016 14.6693C11.6668 14.6693 14.6668 11.6693 14.6668 8.0026C14.6668 4.33594 11.6668 1.33594 8.00016 1.33594C4.3335 1.33594 1.3335 4.33594 1.3335 8.0026C1.3335 11.6693 4.3335 14.6693 8.00016 14.6693Z",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8 5.33594V8.66927",
    stroke: "#1E2A3B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8 5.33594V8.66927",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8 5.33594V8.66927",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8 5.33594V8.66927",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8 5.33594V8.66927",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99658 10.6641H8.00257",
    stroke: "#1E2A3B",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99658 10.6641H8.00257",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99658 10.6641H8.00257",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99658 10.6641H8.00257",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99658 10.6641H8.00257",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircle);
export default __webpack_public_path__ + "static/media/info-circle.cef44ff7c39d7773930096f44bf6297c.svg";
export { ForwardRef as ReactComponent };